import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MetadataProp } from '../../models/metadata-prop-model';
import { MetadataService } from '../../services/metadata.service';
import { ResultSelectionService } from '../../services/result-selection.service';
import { environment } from '../../../environments/environment';
import { FoldersService } from '../../services/folders.service';
import { ConstantsService } from '../../services/constants.service';

@Component({
  selector: 'app-reports-dialog',
  templateUrl: './reports-dialog.component.html',
  styleUrls: ['./reports-dialog.component.css']
})
export class ReportsDialogComponent implements OnInit {

  @Input() createReportVisible: boolean = false;
  @Output() closeDialog = new EventEmitter();
  @Output() executeDownload = new EventEmitter();
  props: MetadataProp[] = [];
  selectedProperties: MetadataProp[] = [];
  reportType: string = 'Excel';
  propertyOption: string = 'all';
  selectionInvalid = false;
  itemCount: number = 0;
  docMax: number = 0;
  selectedLib: string;

  constructor(private mdSvc: MetadataService, private selectionSvc: ResultSelectionService, private folderSvc: FoldersService, private constants: ConstantsService) {
    this.selectedLib = this.constants.indexEHD;
  }

  ngOnInit(): void {
    this.props = this.mdSvc.getReportable();
    this.docMax = environment.results_max;
    this.selectionSvc.selectedCount$.subscribe(c => { this.itemCount = c; });
  }

  executeClose() {
    this.closeDialog.emit();
  }

  executeReport() {
    this.validateSelections();
    if (!this.selectionInvalid) {
      let options = {
        'fileType': this.reportType,
        'downloadType': this.propertyOption,
        'props': this.selectedProperties
      }
      this.executeDownload.emit(options);
    }
  }

  validateSelections() {
    if ((this.propertyOption !== 'all') && (this.selectedProperties.length < 1)) {
      this.selectionInvalid = true;
    }
    else {
      this.selectionInvalid = false;
    }
  }

  clearValidation() {
    this.selectionInvalid = false;
  }
}
